module.exports = __webpack_public_path__ + "img/landing-carousel-2.5dd94b98.png";